import script from "./PerfilMenusEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilMenusEditPage.vue?vue&type=script&setup=true&lang=js"

import "./PerfilMenusEditPage.vue?vue&type=style&index=0&id=225e22e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225e22e8"]])

export default __exports__